import { Row } from "reactstrap";
import styled from "styled-components";

export const RowWithMarginTop = styled(Row)`
	margin-top: ${p => p.theme.margins.top}
`;